import { useEffect, useRef, useState } from "react";
import { ControllerSitInButtonGroup } from "../sit-in/style";
import { TimerControllerPopupInputWrapper } from "../../style";
import { useRecoilValue } from "recoil";
import {
  getPubMemberList,
  getUserSearchByNickname,
  joinMemberApi,
  MemberResponse,
  UserMemberResponse,
} from "../../../../api/member";
import { pubState } from "../../../../recoil/pub.atom";
import {
  ControllerMemberJoinSearchWrapper,
  ControllerMemberJoinText,
  ControllerMemberJoinWrapper,
} from "./style";
import {
  ControllerMemberSearchListWrapper,
  ControllerMemberSearchListItem,
} from "../sit-in/components/participation/style";
import { WideState } from "../../../../recoil/wide";
import { PubMemberDto } from "../../../../api/member";

export interface ControllerMemberJoinProps {
  joinMember: UserMemberResponse | null;
  setMember: (v: PubMemberDto | null) => void;
  onClose: () => void;
}

const TimerControllerMemberJoin = ({
  joinMember,
  setMember,
  onClose,
}: ControllerMemberJoinProps) => {
  const pub = useRecoilValue(pubState);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const isWide = useRecoilValue(WideState);
  const [searchMember, setSearchMember] = useState<MemberResponse | null>(null);

  useEffect(() => {
    handleSearchMember();
  }, [joinMember]);

  const handleSearchMember = async () => {
    if (!pub || !joinMember) return;

    try {
      const result = await getUserSearchByNickname(
        joinMember.nickname,
        pub?.id,
      );
      setSearchMember(result.payload);
    } catch (e: any) {
      if (e.response && e.response.status === 404) {
        alert("검색한 닉네임을 찾을 수 없습니다.");
      } else {
        alert("에러가 발생했습니다. 다시 시도해주세요.");
      }
    }
  };

  const handleJoinMember = async () => {
    if (!pub || !joinMember) return;

    const req = {
      nickname: joinMember.nickname,
      phoneNumber,
      pubId: pub.id,
    };
    try {
      await joinMemberApi(req);
      handleSelectMember();
    } catch (e: any) {
      alert(e.message);
    }
  };

  const handleSelectMember = async () => {
    if (!pub || !joinMember) return;
    const result = await getPubMemberList(joinMember.nickname, pub.id);
    setMember(result?.memberList[0]);
    onClose();
  };

  const canButton = () => {
    return joinMember && phoneNumber;
  };

  return (
    <ControllerMemberJoinWrapper isWide={isWide}>
      <div className="title">회원 검색</div>
      <ControllerMemberJoinSearchWrapper>
        <div className="input-wrapper">
          <TimerControllerPopupInputWrapper disabled={true}>
            <input value={joinMember?.nickname} disabled={true} />
          </TimerControllerPopupInputWrapper>
          <TimerControllerPopupInputWrapper>
            <input
              ref={inputRef}
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="전화번호 뒷 4자리를 입력해주세요. "
              onKeyDown={(e) => {
                if (e.key === "Enter") handleJoinMember();
              }}
            />
          </TimerControllerPopupInputWrapper>
        </div>
        <ControllerMemberJoinText>
          <div>
            러너펍 첫 방문 여부: {searchMember?.alreadyMember ? "X" : "O"}
          </div>
        </ControllerMemberJoinText>
      </ControllerMemberJoinSearchWrapper>
      <ControllerSitInButtonGroup>
        <div
          className={`button ${canButton() ? "purple" : "gray"}`}
          onClick={() => {
            if (!canButton()) return;
            handleJoinMember();
          }}
        >
          저장
        </div>
        <div className="button" onClick={onClose}>
          취소
        </div>
      </ControllerSitInButtonGroup>
    </ControllerMemberJoinWrapper>
  );
};

export default TimerControllerMemberJoin;
